import { useQuery } from "react-query";
import {
    GetKantungParkirResponse,
    ParamsGetKantungParkir,
} from "../../constants/types";
import axios from "../axios";

const queryString = require("query-string");

const handleRequest = async (params: ParamsGetKantungParkir) => {
    const apiGetKantungParkir = queryString.stringifyUrl({
        url: "/api/kantungparkirs",
        query: {
            size: params.size,
            page: params.page,
        },
    });
    const { data } = await axios.get<GetKantungParkirResponse>(
        apiGetKantungParkir,
    );
    return data.data;
};

export default function useKantungParkir(params: ParamsGetKantungParkir) {
    return useQuery<GetKantungParkirResponse["data"]>(
        ["kantung-parkir", params],
        () => handleRequest(params),
    );
}
